import {RegisterValue} from "./register";
import {Cursor} from "./cursor";

export class ErrorRegisterHasNoValueOrReference extends Error {
    constructor() {
        super(`Register has no value or reference set (it must have one or the other)`);
    }
}
export type RegisterReference = string[];
export type MarshalValueData = {
    value?: RegisterValue
    reference?: RegisterReference
}
export class MarshalValue {
    private readonly marshalValue?: RegisterValue;
    private readonly marshalReference?: RegisterReference;

    constructor(data: MarshalValueData) {
        this.marshalValue = data.value;
        this.marshalReference = data.reference;
    }

    public get reference(): string | undefined {
        return this.marshalReference ? this.marshalReference[0] : undefined;
    }
    public get marshal(): RegisterValue | RegisterReference | undefined {
        return this.marshalReference ?? this.marshalValue;
    }

    public value(cursor: Cursor): RegisterValue {
        const reference = this.reference;

        if (reference !== undefined) {
            return cursor.getRegisterValue(reference);
        } else if (this.marshalValue === undefined) {
            throw new ErrorRegisterHasNoValueOrReference();
        } else {
            return this.marshalValue;
        }
    }

    public serialise(): MarshalValueData {
        if (this.marshalReference) {
            return {reference: this.marshalReference}
        } else {
            return {value: this.marshalValue}
        }
    }
}